/* eslint-disable max-lines */
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import H2 from '@base/H2/H2';
import P1 from '@base/P1/P1';
import H3 from '@base/H3/H3';
import ContentsTable from '@base/ContentsTable/ContentsTable';
import MenusNav from '@base/MenusNav/MenusNav';
import { menus } from '@utils/constants';
import { Spacings } from '@styles/index';
import Layout from '@layout/index';
import Image from '@base/Image';
import LeftContainer from '@cont/CompanyDetails/LeftContainer';
import RightContainer from '@cont/CompanyDetails/RightContainer';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import H6 from '@base/H6/H6';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 24;
`;

const StyledH3 = styled(H3)`
  margin-bottom: ${Spacings.SPACING_6B};
  padding-top: 100px;
  margin-top: -100px;
`;

const Paragraph = styled(P1)`
  margin-bottom: ${Spacings.SPACING_4B};
  text-align: justify;
`;

const StyledParagraph = styled(Paragraph)`
  margin-bottom: ${Spacings.SPACING_4B};
  ol > li {
    margin-bottom: ${Spacings.SPACING_2B};
    &:first-of-type {
      margin-top: ${Spacings.SPACING_2B};
    }
  }
`;

const LearnerPolicyHeading = styled(H6)`
  text-align: center;
  margin-bottom: ${Spacings.SPACING_8B};
`;

const StyledOl = styled.ol`
  list-style-type: lower-alpha;
`;
const Link = styled.a``;

const ListItem = ({ children }) => (
  <StyledParagraph as="li">{children}</StyledParagraph>
);

const tableData = [
  {
    label: 'Eligibility and Enrolment',
    id: 'eligibility_and_enrolment'
  },
  { label: 'Ranking and Rewards', id: 'ranking_and_rewards' },
  {
    label: 'Personal Information',
    id: 'personal_information'
  },
  {
    label: 'Consent And Waiver By Participants',
    id: 'consent_and_waiver_by_participants'
  },
  { label: 'General Terms and Conditions', id: 'general_terms_and_conditions' },
  { label: 'Disclaimers', id: 'disclaimers' },
  {
    label:
      'Contest Specific Terms and Conditions - Unacademy National Scholarship Admission Test (UNSAT)',
    id: 'contest_specific'
  },
  {
    label: 'FAQs - Offline and online tests',
    id: 'faq'
  }
];

const RankPredictorTerms = () => {
  const router = useRouter();
  const { pathname } = router;

  return (
    <>
      <LeftContainer>
        <MenusNav data={menus} currentHref={pathname} />
      </LeftContainer>

      <RightContainer>
        <Wrapper>
          <div>
            <div>
              <H2>Unacademy Contests Terms and Conditions</H2>
            </div>
            <br />
            <br />
            <ContentsTable data={tableData} />
            <Paragraph>
              Unacademy Contest Term and Conditions (“Contest Terms”) is made
              available to you by M/s Sorting Hat Technologies Private Limited
              (collectively referred to as “us” “we” “Unacademy”). These Contest
              Terms govern the relationship between persons who wish to
              participate in contests that are made available and organized by
              Unacademy (“Contest(s)”) to the users of www.unacdemy.com and/or
              the Unacademy Apps (referred to as “Unacademy Platform”) either
              remotely or in person (collectively referred to as “you” your(s)”
              “Participant(s)”). The Participants and Unacademy shall be
              collectively referred to as Parties and individually as Party. The
              terms and conditions and privacy policies and other policies made
              available on the Unacademy Platform (“Platform Terms”) shall be
              valid and binding on all Participants. All capitalized terms not
              defined herein shall have the meaning assigned to it under the
              Platform Terms. Unacademy shall from time to time communicate
              contest specific terms and conditions that shall also be binding
              on the Participants (“Contest Specific Terms”). The Platform
              Terms, Contest Terms and any other Contest Specific Terms shall
              collectively be referred to as “Terms and Conditions”. By
              participating in the Contest, the Participant agrees to be bound
              by the Terms and Conditions.
            </Paragraph>
            <br />
            <br />
            <a name={tableData[0].id}>
              <StyledH3>{tableData[0].label}</StyledH3>
            </a>
            <Paragraph>
              In order to be a Participants in the Contests, the Participants
              must conform to the following eligibility criteria (unless
              specified otherwise) in addition to eligibility criteria in the
              Contest Specific Terms:
              <br />
              <br />
              <ol>
                <ListItem>an Individual;</ListItem>
                <ListItem>an Indian citizen;</ListItem>
                <ListItem>in India;</ListItem>
                <ListItem>legally eligible to enter into a contract;</ListItem>
                <ListItem>user of the Unacademy Platform;</ListItem>
              </ol>
              The Contests are open to participation by individuals only.
              Corporate entities, agencies and any non-human legal entities are
              barred from participating in the Contest. Employees, consultants,
              interns and educators of Unacademy are not allowed to participate
              in Contests conducted by Unacademy.
              <br />
              <br />
              The Participants may be required to pay a participation or
              enrolment fee in order to take part in the Contest the details of
              which shall be as specified in the Contest Specific Terms.
              <br />
              <br />
              Participants are not bound in any way to participate in the
              Contests. Any participation is voluntary, and the Contest is being
              made available purely on a best effort basis. Unacademy, in its
              sole discretion, reserves the right to disqualify the Participant
              from the benefits and Rewards of the Contest, if any fraudulent
              activity is detected or on any breach of the Terms and Conditions
              by the Participant.
            </Paragraph>
            <br />
            <br />
            <a name={tableData[1].id}>
              <StyledH3>{tableData[1].label}</StyledH3>
            </a>
            <Paragraph>
              Each Contest shall have its own specific selection criteria,
              ranking and rewards system as specified in the Contest Specific
              Terms. Subject to the Contest Specific Terms, Unacademy may, at
              its sole discretion, choose to reward Participants who won the
              Contest (“Rewards”).
              <br />
              <br />
              Unacademy reserves the right at its sole discretion to modify,
              withdraw, suspend, extend, add reschedule or cancel the Contest or
              the Rewards under the Contests at any time without any prior
              written notice.
              <br />
              <br />
              The Participants understands that obtaining a high rank in any
              Contest does not automatically qualify them for Rewards under the
              Contest and shortlisting of Participants is based on selection
              parameters of Unacademy set out in the Contest Specific Terms, as
              determined by Unacademy in its sole discretion.
              <br />
              <br />
              The shortlisted Participants may be contacted and be required to
              submit additional information / documentation as may be essential
              for Unacademy to provision the Rewards. Unacademy does not accept
              any responsibility for any incorrect and/or incomplete
              communication details provided and/or delay in receipt of
              communication and/or non-receipt of communication.
              <br />
              <br />
              Finally, upon collection and verification of the required
              documentation (as required), Rewards shall be processed to the
              shortlisted Participants within timeline as maybe determined by
              Unacademy at its sole discretion.
              <br />
              <br />
              Unacademy shall have the sole discretion to reject the Participant
              or choose another Participant in place of the originally
              shortlisted Participant if: (a) the documents or details provided
              by the Participant are invalid/incorrect/incomplete/ misleading
              /untrue or not acceptable in the opinion of Unacademy; (b) the
              Participant has not conformed to any of the terms and conditions
              contained herein; (c) the Participant does not sign the consent
              form or any other documents required, if any, by Unacademy
              concerning the Contest; (d) any other reason as may be deemed
              appropriate by Unacademy.
              <br />
              <br />
              The process of selection, number of Participants shortlisted for
              the Rewards and the type or form of Reward are to be determined,
              and shall be subject to change, at the sole discretion of
              Unacademy and the decision of Unacademy shall be final and
              binding. The Participants are encouraged to check the Terms on a
              periodic basis to ensure that they do not miss out on any updates
              and modifications.
            </Paragraph>
            <br />
            <br />
            <a name={tableData[2].id}>
              <StyledH3>{tableData[2].label}</StyledH3>
            </a>
            <Paragraph>
              A Participant’s Personal Information, including Sensitive Personal
              Information, that may be collected to enable the Contest, provide
              ancillary services related to the Contest and delivery of the
              Rewards, shall be collected, processed, and stored in accordance
              with the Unacademy’s Privacy Policy. Participants shall have all
              the rights available to them under the applicable Data Protection
              Laws in accordance with the Unacademy Privacy Policy.
              <br />
              <br />
              Unacademy shall use a Participant’s Personal Information for
              facilitating Contests and rendering the Services with respect to
              the Platform in the most effective manner, to secure the Platform
              and make improvements, to perform market research and product
              analysis, to carry out Unacademy’s obligations towards the
              Participant, and to communicate with the Participant. The said
              communication can either be by calls, text, or emails and for the
              purposes of conducting the Contest itself, transactional, service,
              advertising or promotional calls or messages about the Contest(s)
              and other offers, new products or services made available by
              Unacademy and the Participant hereby consents to the same. Any
              deletion request received from a Participant in respect of their
              Personal Information shall be processed in accordance with
              Unacademy Privacy Policy.
              <br />
              <br />
              Notwithstanding the foregoing, in the event a Participant has
              already received a Reward prior to a deletion request /
              withdrawing consent for use of its information, Unacademy shall
              comply with such request as per the terms of the Privacy Policy,
              subject to the said Participant refunding/returning the reward
              received by such Participant pursuant to these Contest Terms.
            </Paragraph>
            <br />
            <br />
            <a name={tableData[3].id}>
              <StyledH3>{tableData[3].label}</StyledH3>
            </a>
            <Paragraph>
              The Participant hereby consents to the use by Unacademy of his/her
              name, age, photograph, videos, voice recordings, rank, statements
              and/or testimonials (“Personal Attributes”) for the purpose of
              publication, advertising, promotion on its online platforms,
              including but not limited to the Unacademy Platform, and through
              any mode, medium, platform and/or format, including without
              limitation, in newspapers, magazines, other print media, on
              television, radio, internet and other electronic and/or in
              mailings for educational awareness.
              <br />
              <br />
              Any testimonial or statements provided by the Participant and any
              other details pertaining to the Contest, the Rewards they have
              won, their use of the Platform, content available on the Platform,
              shall be exclusively provided to Unacademy and the Participant
              warrants to that extent.
              <br />
              <br />
              Any marketing material created by Unacademy using a Participant’s
              Personal Attributes shall remain the sole property of Unacademy,
              and the Participant shall have no claim of any nature against the
              same. The Participant understands that the use of his/her Personal
              Attributes by Unacademy shall be made at its sole discretion
              without any further notice to the Participant. Unacademy shall
              have no obligation to consider Participant’s inputs or feedback on
              the use of his/her Personal Attributes.
              <br />
              <br />
              The Participant shall release, waive, and discharge claims of any
              kind or nature arising out of or relating to the use of his/her
              Personal Attributes against Unacademy or any person or firm
              authorized by Unacademy to publish the same in accordance with the
              terms hereof. Such release, waiver and discharge shall also extend
              to all group companies, affiliated companies, subsidiaries,
              shareholders, directors, officers, employees, agents and assigns
              of Unacademy and any publishers of the Personal Attributes in
              accordance with the terms hereof. Such a release shall be binding
              on the Participant, his/her respective successors, heirs, assigns,
              executors, administrators, spouse and next of kin.
              <br />
              <br />
              The Participant hereby confirms that the chance provided by
              Unacademy to be recognized as winner in the Contest(s) and
              delivery of Rewards if any, in accordance with these Contest
              Terms, is sufficient consideration for the use of Participant’s
              Personal Attributes by Unacademy in accordance with the terms
              hereof, and Unacademy shall have no liability to pay any
              consideration for any use of the Participant’s Personal Attributes
              in accordance with these Contest Terms.
            </Paragraph>
            <br />
            <br />
            <a name={tableData[4].id}>
              <StyledH3>{tableData[4].label}</StyledH3>
            </a>
            <Paragraph>
              Information that is available on the official Contest page or
              communicated on Unacademy’s official social media handles shall be
              the only authentic and valid information with respect to the
              Contests. Unacademy shall not be responsible for any
              incorrect/misleading information relating to the Contest,
              presented/ displayed on any other source other than the Contest
              page on Unacademy Platform shall not be liable for any loss
              suffered by any Participants based on the representation, Terms,
              the information presented/displayed on any other source other than
              the Contest page on the Unacademy Platform.
              <br />
              <br />
              A Participant who has received a Reward for one Contest shall not
              be eligible for the Reward in the next edition of the same
              Contest, unless allowed specifically in the Contest Specific
              Terms. A Participant who has received a Reward under the
              sub-category of one Contest shall not be eligible for Rewards
              under another sub-category in the same Content irrespective of the
              Ranking.
              <br />
              <br />
              After the results are announced, Unacademy will conduct a thorough
              evaluation to determine if the Participants have conducted
              themselves in accordance with the Terms.
              <br />
              <br />
              If at any point in time it is brought to the attention or
              knowledge of Unacademy that the Participant have engaged in any
              unethical practices including but not limited to having prior
              access to the questions in the Contest, usage of any circumventing
              technology to manipulate the product algorithm or any act which
              will give the Participant an unfair advantage over other
              Participants, engaged in any form of mal-practice, Unacademy may
              at its sole discretion cancel any Reward or reward due to the
              Participant and bar the Participant for using any product or
              services offered by Unacademy.
              <br />
              <br />
              All Rewards are subject to the Participants adhering to the Terms
              and Conditions and shall be subject to the laws of India,
              including all the applicable tax laws.
              <br />
              <br />
              Unacademy has endeavored to make all reasonably practicable
              arrangements to minimize communication system difficulties or any
              other technical issues but can make no guarantee thereof and shall
              not be liable for any failures in the same. Unacademy shall not be
              responsible and/or liable in any manner whatsoever in case the
              Participant is unable to participate due any technical issues or
              due to the issues with their internet provider, hardware, facility
              provider, etc.
              <br />
              <br />
              Any Participant found participating in the Test through multiple
              accounts or in the event any person impersonates a Participant,
              such Participant(s) shall be disqualified immediately and shall
              not be entitled to any Rewards. The Participant shall be barred
              from participating in any future Contests, tests etc. at the sole
              discretion of Unacademy.
              <br />
              <br />
              Any Participant taking part in Contest and is declared winner in
              the Contest by Unacademy and is unable to fulfil any one or more
              eligibility requirements, as specified in the Terms shall be
              disqualified from receiving any Reward. Any communication,
              clarification, query, dispute in this regard by the Participant,
              or any of the legal heirs/guardians of the Participant in any
              manner shall not be entertained by Unacademy.
              <br />
              <br />
              Unacademy will not be responsible, in case anyone is unable to
              participate in the Contest on account of not having access to the
              Contest.
              <br />
              <br />
              Participant/s winning the Reward/s shall be contacted by Unacademy
              via email or any other mode of communication. Unacademy shall not
              be liable for any loss, claim, damage, expenses whether expressed,
              implied, real, or consequential incurred by the Participant due to
              participation, non-participation or otherwise in the Contest.
              Unacademy shall not be liable for any loss that occurs during the
              dispatch of the Reward to the Participant’s address Unacademy
              shall not be responsible for paying any applicable taxes, fee,
              charges, etc. related to the Reward.
              <br />
              <br />
              Any query regarding the Contest will be entertained only for 1
              (one) month from date of the participation in the Contest. Post
              such timeframe, Unacademy will not entertain any correspondence or
              communication regarding the Contest from any person.
              <br />
              <br />
              Unacademy shall not be responsible for any deficiency in the
              Rewards and does not make a representation about the quality,
              make, performance, features, endurance, finishing, benefits, or
              fitness of the Rewards and neither does Unacademy endorse the
              services or goods provided by the manufacturers/service providers
              of the Rewards.
              <br />
              <br />
              Any disputes with respect to Contest shall subject to be governed
              by and construed in accordance with the laws of India, without
              reference to principles of conflict of laws and the courts in
              Bangalore shall have the exclusive jurisdiction to determine any
              disputes arising out of, under, or in relation to, the Contest.
              <br />
              <br />
              The Participant shall indemnify and hold harmless Unacademy, its
              officers, employees, agents, licensees, etc against any and all
              damages, claims, losses, demands, actions, causes of action,
              suits, litigation, costs and expenses (including but not limited
              to, the publication of response(s) submitted by the Participant as
              a part of, or in association with the Contest without limitation,
              reasonable attorneys’ and consultants’ fees).
              <br />
              <br />
              Unacademy shall not be liable for any failure to comply with its
              obligations caused by weather conditions, fire, flood, strike,
              hurricane, industrial dispute, war, hostilities, terrorist attack,
              political unrest, riots, civil commotion, inevitable accidents,
              pandemic and/or epidemic, acts of God or any other circumstances
              amounting to Force Majeure.
              <br />
              <br />
              Unacademy shall not be responsible for any loss or damage if
              Unacademy is required to discontinue or cancel the Contest in
              compliance with any law, ruling, order, regulation, requirement,
              or instruction of any Central/State Government or for any other
              unavoidable reason beyond its control. The Participants shall be
              informed of such discontinuance/cancellation as early as possible.
              <br />
              <br />
              The aggregate liability of Unacademy in case of any damage, loss,
              cost, claim, liability, or expense (including legal costs and
              expenses) caused to or incurred by any act, omission, or
              representation in respect of the Reward, shall not exceed any
              participation or enrolment fee paid for the Contest. Further,
              Unacademy shall not be liable to share the invoice of the Reward
              with the Participant at any given point of time whatsoever.
            </Paragraph>
            <br />
            <br />
            <a name={tableData[5].id}>
              <StyledH3>{tableData[5].label}</StyledH3>
            </a>
            <Paragraph>
              Unacademy and/or its subsidiaries/affiliates shall not be under
              any obligation to the Participant in relation to the Contest and
              the Participant shall have no claims whatsoever against Unacademy
              and/or its subsidiaries/affiliates relating to the selection
              process, gratification, or the running of the Contest.
              <br />
              <br />
              Unacademy shall not be responsible for any errors or omissions in
              the terms and conditions contained herein. All information
              provided is provided “as is” without warranty of any kind. To the
              fullest extent permitted by applicable law, Unacademy disclaims
              all warranties, express or implied, including without limitation,
              implied warranties of merchantability, fitness for a particular
              purpose, and non-infringement in respect of the Contest
              <br />
              <br />
              Unacademy shall have the sole discretion to discontinue / cancel
              the Contest or any part thereof at any point in time and the
              Participant shall not raise any claim due to such discontinuation
              or cancellation at any time whatsoever.
              <br />
              <br />
              Unacademy shall not be held responsible in case of a server
              shutdown or loss of Participants’ registration and/or other data.
              Unacademy shall not be responsible for any delay in receipt or
              non-receipt or incomplete or corrupt receipt of the registration
              or, other details of the Participant. Unacademy shall not be
              responsible for any technical difficulties or data corruption that
              may arise during the registration process. Further, Unacademy
              shall not be responsible and/or liable in any manner whatsoever in
              case the Participant is unable to register for participation in
              the Contest due to failure on part of the internet service
              provider, facility provider, etc.
            </Paragraph>
            <a name={tableData[6].id}>
              <StyledH3>{tableData[6].label}</StyledH3>
            </a>
            <Paragraph>
              The Unacademy National Scholarship Admission Test (“UNSAT” and/or
              “Test”) is a scholarship test organized by M/s Sorting Hat
              Technologies Private Limited (“Unacademy”). UNSAT shall be valid
              only within the territory of India. UNSAT shall be governed by the
              following terms and conditions as well as the Unacademy Contests
              Terms and Conditions available on the Unacademy Platform
              (collectively referred to as “Terms”)
              <br />
              <br />
              UNSAT shall be conducted online (“Online Test”) and offline
              (“Offline Test”) according to the schedule (“Test Schedule”) for
              Foundation, NEET UG and IIT JEE categories (each a “Category and
              collectively the Categories”) as given below:
              <br />
              <br />
              <b>Offline Test Schedule</b>
              <br />
              <br />
              <StyledOl>
                <li value="a">
                  The Offline Tests shall be conducted at several premises
                  including schools with which Unacademy has partnered with on
                  12th, 13th, 14th October 2022.
                </li>
                <li value="b">
                  The Offline Tests shall be conducted between 8th October 2022
                  and 15th October 2022, in multiple cities, as may be
                  determined by Unacademy.
                </li>
                <li value="c">
                  Whilst there shall be no enrollment fee applicable for the
                  Offline Tests conducted at the offline partner schools, an
                  enrollment fee of INR 99 (Indian Rupees Ninety-Nine only)
                  shall apply for the Offline Tests conducted at any other
                  premises.
                </li>
              </StyledOl>
              <br />
              <b>Online Test Schedule</b>
              <br />
              <br />
              The Online Tests shall be conducted online, accessible through the
              web and/or mobile Apps of Unacademy, on the 8th and 15th of
              October 2022. There shall be an enrollment fee of INR 99 (Indian
              Rupees Ninety-Nine only) applicable for the Online Tests.
              <br />
              <br />
              <ol>
                <b>A. Eligibility and Participation</b>
                <ol>
                  <br />
                  <ListItem>
                    In order to participate in UNSAT, individuals will have to
                    be student of Class VI, VII, VII IX, X, XI, XII and/or those
                    who have dropped to attempt the official examinations in the
                    Categories. Those participating in UNSAT shall be
                    hereinafter referred to as the “Participant/s”.
                  </ListItem>
                  <ListItem>
                    In order to qualify as a Participant of Tests, individuals
                    shall be required to enroll for UNSAT on the official
                    enrolment page of UNSAT (“Contest Page”) on the Unacademy
                    Platform, using their mobile number, and, if applicable, pay
                    an enrolment fee as provided hereinabove. . This fee shall
                    be non-refundable.
                  </ListItem>
                  <ListItem>
                    Once the fee is paid, an admit card will be issued to the
                    Participant along with other details related to UNSAT
                    including, date, timing and duration of tests, number of
                    slots available for the Tests (“Test Details”) and, in case
                    of Offline Tests, also details of the centre where the
                    Offline Tests will be conducted (“Centre”). The Test Details
                    will also be made available on the Contest Page.
                  </ListItem>
                  <ListItem>
                    In case of the Offline Tests, Unacademy does not in any way
                    represent that the Centres will be in the city/town that a
                    Participant resides in. In the event there are no Centres in
                    the city where the Participants reside in, the Participants
                    may travel to any one of the other cities nearest to the
                    Participant.
                  </ListItem>
                  <ListItem>
                    In case of an Offline Test, enrolment shall close at least 4
                    (four) prior to the date of conducting such Offline Test.
                  </ListItem>
                  <ListItem>
                    After the completion of a Test, the Participant shall
                    receive a score and a rank secured in the Test. It is
                    clarified that this rank shall not be final for the purpose
                    of any scholarships or rewards (“Rewards”) and all India
                    rank of a Participant (which shall be made notified on or
                    before 21st October 2022 (“Final Rank”)) shall be considered
                    as relevant for the purposes of Rewards.
                  </ListItem>
                </ol>

                <br />
                <br />

                <b>B. Rewards</b>
                <br />
                <br />
                <ul style={{ listStyleType: 'none' }}>
                  <ListItem>
                    1. At the discretion of Unacademy, once the Final Ranks are
                    announced, the Participants may be eligible for one of the
                    following Rewards:
                  </ListItem>
                  <ListItem>
                    a. Up to 100% scholarships for the Participants of the
                    Offline and Online Tests, in the manner, and to the extent,
                    set out below:
                  </ListItem>
                  <Image
                    src="tnc/unsat-table-a.png"
                    width={750}
                    height={500}
                    alt="table"
                  />
                  <br />
                  <br />

                  <ListItem>
                    2. Participants who have Final Ranks in the IIT JEE
                    Category, may at the sole discretion of Unacademy, and
                    subject to the internal parameters as determined by
                    Unacademy be selected for the Special Rankers’ Group (SRG)
                  </ListItem>
                  <ListItem>
                    3. The Participants will be given their Final Ranks with
                    detailed performance reports on the Tests.
                  </ListItem>
                  <ListItem>
                    4. The Rewards shall not be construed as cash rewards or
                    equivalent and cannot be exchanged for cash or kind at any
                    point of time.
                  </ListItem>
                  <ListItem>
                    5. The discount for Unacademy Centre subscription or online
                    plus subscriptions on the Unacademy Platform can be availed
                    only for one category and the scholarship cannot be applied
                    to multiple categories or goals.
                  </ListItem>
                  <ListItem>
                    6. The Participants shall be required to avail the Rewards
                    on or before 5th November 2022 (“Cut-off Date”). The
                    Participants will be required to provide such information as
                    may be requested by Unacademy, for verification of the
                    Participants and enabling the distribution of the Rewards.
                  </ListItem>
                  <ListItem>
                    7. The Rewards shall be subject to such other terms and
                    conditions as may be determined by Unacademy at its sole
                    discretion, from time to time.
                  </ListItem>
                  <ListItem>
                    8. 5 (Five) Participants of the Offline Test, who have
                    availed the Reward on or before the Cut-off Date, subject to
                    their performance and the internal parameters as determined
                    by Unacademy, shall be eligible for a special reward
                    (“Special Reward”) which shall be a trip to the Euro Space
                    Centre. The Special Reward shall be subject to the following
                    additional terms: <br /> <br />
                    <StyledOl>
                      <li>
                        The Participant should have become eligible for a Reward
                        and availed the same on or before the Cut-off Date for
                        the Tests conducted for any of the following Categories:
                        <br />
                        <ul>
                          <li>
                            Class VI, Class VII, Class VIII, Class IX, Class X,
                          </li>
                          <li>
                            Class XI- IIT JEE, Class XI- NEET (UG), Class XI
                            (Board)
                          </li>
                          <li>
                            Class XII- IIT JEE, Class XII- NEET (UG), Class XII
                            (Board)
                          </li>
                          <li>
                            Class Dropper- IIT JEE, Class Dropper- IIT JEE
                          </li>
                        </ul>
                      </li>
                      <li>
                        If a Participant is a minor, he / she shall be
                        accompanied by one parent/guardian (“Guardian”) for the
                        trip.
                      </li>
                      <li>
                        The expenses to be borne by Unacademy shall be limited
                        to travel, accommodation, meal expenses, activity
                        expenses (if any), at cost. Any other expenses such as
                        independent, travel, purchases etc. outside of the
                        itinerary set by Unacademy shall be borne by the
                        Participant and Unacademy shall not reimburse the same
                        or entertain any claims to so do.{' '}
                      </li>
                      <li>
                        The Participants and Guardians may be required to travel
                        to a pre-determined location for the trip and all
                        expenses related to the same shall be borne by the
                        Participants / Guardians. It is hereby clarified that
                        such location shall be within the territory of India
                        subject to availability of flights.
                      </li>
                      <li>
                        The Participants and Guardians shall be required to
                        ensure that they have a valid passport and any other
                        permissions and permits to travel internationally,
                        Unacademy shall at no point of time be required to
                        ensure the same on behalf of the Participants or
                        Guardians.{' '}
                      </li>
                      <li>
                        The duration, date and any other details related to the
                        Special Rewards shall be as determined and communicated
                        by Unacademy.
                      </li>
                    </StyledOl>
                    The Rewards (including Special Rewards) may be revoked,
                    rescheduled, modified or canceled by Unacademy at any point
                    of time and for any reason whatsoever which shall include
                    without limitation non-availability or flights,
                    accommodation, visas etc. or occurrence of any force majeure
                    event.
                  </ListItem>
                </ul>
                <br />
                <br />
                <b>C. Other Terms and Conditions</b>
                <br />
                <br />
                <ol>
                  <ListItem>
                    For the Offline Tests, Participants are encouraged to appear
                    at the Centre a minimum of 30 (thirty) minutes before the
                    commencement of the Tests and in the event a Participant is
                    late, he / she will be required to complete the Tests within
                    the remaining time.
                  </ListItem>
                  <ListItem>
                    Participants shall not do any act which amount to
                    malpractice or cheating and shall adhere to all the Terms,
                    further the Participants shall obey the instructions of the
                    invigilator or any representative of Unacademy at the Centre
                    and shall not act in any manner that amount to harassment,
                    intimidation or causes general disruption or harm to the
                    other test takers or representatives in the Centre. Further
                    the Participant shall not be allowed to carry any of
                    equipment or material in the Centres.
                  </ListItem>
                  <ListItem>
                    For the Offline tests, the representatives of Centres and
                    Unacademy shall have the sole discretion to prevent a
                    Participant from entering the Centre or appearing for the
                    Tests. Such representatives shall have sole authority to
                    request a Participant to leave the Centre in case of any act
                    or omission by the Participant that can be deemed to be
                    disruptive (at the sole discretion of such representative).
                    Further such Participants shall be disqualified from the
                    Tests (including any future tests) and shall not be eligible
                    for any Rewards (including Special Rewards).
                  </ListItem>
                </ol>
              </ol>
              <br />
              <br />
            </Paragraph>
            <Paragraph>
              {' '}
              <LearnerPolicyHeading>
                UNSAT Learner Referral Policy
              </LearnerPolicyHeading>
              <ol>
                <ListItem>
                  The Unacademy Learner Referral Program <b>(“Program”)</b> for
                  the Unacademy National Scholarship Admission Test{' '}
                  <b>(“UNSAT”)</b> is made available, on www.unacademy.com and
                  the Unacademy Apps <b>(“Platform”) </b>owned and operated by
                  M/s Sorting Hat Technologies Private Limited{' '}
                  <b>(“Unacademy”).</b>
                </ListItem>
                <ListItem>
                  The Program shall be subject to the UNSAT Learner Referral
                  Policy provided herein, the Terms and Conditions and Privacy
                  Policy on the Platform and any other policies as may be
                  communicated from Unacademy periodically ( hereinafter
                  collectively referred to as <b>“Terms”</b>)
                </ListItem>
                <ListItem>
                  The users who have purchased a Plus/Iconic subscription to any
                  category on the Platform <b>(“Learners”)</b> shall be eligible
                  to participate in the Program for the duration as communicated
                  by Unacademy <b>(“Term”)</b>.
                </ListItem>
                <ListItem>
                  Each Learner will be provided with a unique referral code
                  <b>(“Code”)</b> ,made available in the account settings of the
                  Learners account on the Platform, which they can copy and
                  share with their family and friends. The Code shall be
                  available only during the Term.
                </ListItem>
                <ListItem>
                  Individuals may use the Code at the time of registration for
                  UNSAT on the Platform, it is clarified that this Program is
                  applicable only for the paid online version of UNSAT.
                </ListItem>
                <ListItem>
                  The Learners will be eligible for a referral reward, in the
                  form of gift vouchers worth INR 75 (Indian Rupee Seventy Five
                  Only) for each successful referral <b>(“Reward”)</b>, subject
                  to the Terms. A successful referral shall mean any individual
                  who uses the Code of the Learner to register for UNSAT by
                  making the requisite payments on the Platform. It is hereby
                  clarified that the Reward shall be disbursed to the eligible
                  Learner in the form of a gift voucher valued at the total
                  consolidated amount that the Learner is eligible for subject
                  to the timelines provided herein only, and Unacademy shall not
                  entertain any requests for exchange or modification of the
                  Reward or any payment is cash or.
                </ListItem>
                <ListItem>
                  Only registrations using the Code shall be considered for the
                  purpose of Rewards and any failure on the part of the
                  individual to enter the Code at all or the correct Code shall
                  not be the responsibility / liability of Unacademy. Further
                  any failure on part of the Learner to display/share the
                  correct Code shall not be the responsibility / liability of
                  Unacademy. Registrations that have been availed using the Code
                  and then cancelled at the request of the individual shall not
                  be counted for the purpose of payments under this Program. In
                  the rare and exceptional event that Unacademy is required to
                  initiate a refund to the individual for any registrations made
                  using the Code, the same shall not be accounted for at the
                  time of Rewards.
                </ListItem>
                <ListItem>
                  The total consolidated Reward shall be disbursed to the
                  Learner within 60 (sixty) days from the expiry of the Term and
                  Unacademy may reach out to the eligible Learners for
                  additional information for the same. In the event the eligible
                  Learner is unable to provide any requested information, the
                  Reward may stand cancelled and/or revoked at the discretion of
                  Unacademy.{' '}
                </ListItem>
                <ListItem>
                  Learners are prohibited from indulging any unethical
                  activities which shall include but not be limited to (i)
                  making any false representations and promises using the Code
                  (ii) offering any compensation in cash or kind to any
                  individual to use the Code (iii) use any circumventing
                  technologies that will give the Learner undue advantage (iv)
                  use of any paid marketing websites, apps to promote/list the
                  Code (v) any unauthorized use of the trademarks and branding
                  of Unacademy for the purpose of promotions. In the event it is
                  brought to the notice of Unacademy that the Learner has
                  indulged in any unethical practices whether listed here or
                  not, Unacademy reserves the right to take any action that it
                  deems appropriate including cancellation of the Reward,
                  revoking access to accounts and cancellation of subscriptions,
                  without prejudice to any other remedies available to Unacademy
                  under the law.
                </ListItem>
                <ListItem>
                  Unacademy may, at its sole discretion change, modify, amend
                  these Terms and/or revoke, cancel the Program.
                </ListItem>
              </ol>
            </Paragraph>

            <a name={tableData[7].id}>
              <StyledH3>{tableData[7].label}</StyledH3>
            </a>
            <Paragraph>
              <h2>
                <b>Where can I attempt UNSAT?</b>
                <br />
                <br />
              </h2>
              <ul>
                <li>Online Exam- Learners can attempt the test online.</li>
                <li>
                  Offline Exam- Learners can give the test at designated
                  centres.
                </li>
              </ul>

              <br />
              <h2>
                <b>What are the rewards and scholarships for Top Rankers?</b>
              </h2>

              <br />
              <ul>
                <li>
                  Offline Exam - Access to Special Rankers Group, Top Rankers
                  win up to 100% scholarship and a Trip to Euro Space Center.*
                </li>
                <li>Online Exam- Top Rankers win up to 50% scholarship*</li>
              </ul>
              <br />
              <h2>
                <b>Where can I download the Admit card? </b>
                <br />
                <br />
              </h2>
              <p>
                You will receive your Admit card via email, 7 days before UNSAT.
              </p>
              <br />
              <h2>Who can enroll for UNSAT?</h2>
              <br />

              <p>
                Learners studying in Class 9 to 12 for the academic year
                2022-2023 and students pursuing IIT JEE/NEET UG post Class 12
                are eligible to take up UNSAT.
              </p>
              <br />
              <h2>
                <b>What will the mode of the exam be?</b>
                <br />
                <br />
              </h2>
              <ul>
                <li>Online Exam- Website</li>
                <li>Offline Exam - OMR based offline test</li>
              </ul>
              <br />
              <h2>
                <b>Where can I download the Admit card?</b>
                <br />
                <br />
              </h2>
              <p>
                You will receive your Admit card via email; 7 days before UNSAT.
              </p>
              <br />
              <h2>
                <b>What is the syllabus and question paper format?</b>
              </h2>
              <br />
              <a
                href="https://unacademy-prod.s3.ap-southeast-1.amazonaws.com/web-cms/UNSAT+Syllabus+%26+Pattern.pdf"
                target="_blank"
                rel="noreferrer"
              >
                Syllabus.pdf
              </a>
              <br />
              <br />
              <h2>
                <b>
                  Are there any Mock Tests and courses available to prepare for
                  UNSAT?
                </b>
              </h2>

              <br />
              <p>
                Yes. Find below the links for the Mock Tests and courses.
                <ul>
                  <li>
                    <Link
                      href="https://unacademy.com/event/testseries/unsat2.0-iitjee"
                      target="_blank"
                    >
                      Click Here for IIT JEE
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="https://unacademy.com/event/testseries/unsat2.0-neetug"
                      target="_blank"
                    >
                      Click Here for NEET UG
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="https://unacademy.com/event/testseries/unsat2.0-k12"
                      target="_blank"
                    >
                      Click Here for IIT JEE/NEET UG Foundation
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="https://unacademy.com/event/testseries/unsat2.0-k12"
                      target="_blank"
                    >
                      Click Here for Class 9 - 12
                    </Link>
                  </li>
                </ul>
              </p>
              <br />
              <h2>What is the Special Rankers Group?</h2>
              <br />
              <p>
                It is a special group created for top-performing Learners to
                increase their chances of ranking in the top 100. The Batches
                here are curated by Top Educators who mentor and produce AIRs
                every year.
              </p>
            </Paragraph>
          </div>
        </Wrapper>
      </RightContainer>
    </>
  );
};

RankPredictorTerms.pageInfo = {
  name: 'Unacademy Rank Predictor Terms',
  isMWebSupported: true,
  layoutOptions: {
    hideGoalSelector: true,
    disableDarkMode: true
  }
};

export default RankPredictorTerms;
RankPredictorTerms.Layout = Layout;
RankPredictorTerms.Wrapper = PageReduxProvider;
